import find from 'lodash/find'

export const selectFavouriteVenues = state => state.favourites.venues

export const selectFavouriteVenue = (state, { id }) => {
  return find(state.favourites.venues.items, { id })
}

export const selectFavouriteOrders = state => state.favourites.orders

export const selectFavouriteOrder = (state, { id }) => {
  return find(state.favourites.orders.items, { id })
}
